export default "__VITE_ASSET__e2f46d51__"